// src/hooks/cities/useRestoreAllCities.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { restoreAllCities } from "../../api/apiCities";
import parseError from "../../utils/parseError";

const useRestoreAllCities = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreAllCitiesMutate, isPending } = useMutation({
        mutationFn: restoreAllCities,
        onSuccess: (res) => {
            const message = res?.message || "Cities restored successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["cities"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to restore cities");
        },
    });

    return { restoreAllCitiesMutate, isPending };
};

export default useRestoreAllCities;